export const ERROR_INVALID_EMAIL = 'Please enter a valid email address';
export const ERROR_INVALID_URL = 'Please enter a valid url';
export const ERROR_INVALID_NUMBER = 'Please enter a number';
export const ERROR_FIELD_REQUIRED = 'This field is required';

class Utils {
  static generateGroupId(sectionLabel, sectionId, fieldId) {
    const label = sectionLabel
      ? sectionLabel
          .toLowerCase()
          .replace(/^\s+|\s{1,100}$/g, '_')
          .replace(/[^\w-]+/g, '')
      : 'sectioninitial';
    const id = sectionId || 'sectioninitial';
    return label + '@' + id + '@' + fieldId;
  }

  static setNewPointersOfDicsInArray(arr) {
    return arr.map((item) => {
      return { ...item };
    });
  }

  static setNewPointersOfDicsInDic(dic) {
    const dicStr = JSON.stringify(dic);
    return JSON.parse(dicStr);
  }

  static isNumber(value) {
    return typeof value === 'number' && (isFinite(value) || isNaN(value));
  }

  static isNull(value) {
    return this.isNumber(value) ? isNaN(value) : value === undefined || value === null || value === '' || value === '';
  }

  static isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else if (this.isObject(value)) {
      return Object.keys(value).length === 0;
    } else {
      return this.isNull(value);
    }
  }

  static isObject(value) {
    return (typeof value === 'object' || typeof value === 'function') && value !== null;
  }

  static isObjectEmpty(value) {
    return (typeof value === 'object' || typeof value === 'function') && value !== null && (Object.values(value).every(x => x === null || x === '' || x === undefined));
  }


  static isFunction(value) {
    return value && {}.toString.call(value) === '[object Function]';
  }

  static equals(obj1, obj2) {
    if (this.isNull(obj1) && this.isNull(obj2)) {
      return true;
    }
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  static getRandomNum() {
    const int = window.crypto.getRandomValues(new Uint32Array(1))[0]
    return int / 2 ** 32;
  }

  static generateUUID() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (d + Utils.getRandomNum() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  static validateEmail = (email) => {
    const expression = /^[\w\-.]+@[\d\-A-Za-z]+\.+([\dA-Za-z]{2,4})$/;
    return !!expression.test(email);
  };

  static validateNumber = (value) => {
    const decimal = /^[0-9]\d*(\.\d+)?$/;
    const number = /^[0-9]\d*$/;

    if (decimal.test(value) || number.test(value) || (value && value[value.length - 1] === '.')) {
      return value;
    } else {
      if (value) {
        return value.replace(value.substring(value.length - 1), '');
      }

      return '';
    }
  };

  static validateUrl(url) {
    if (url === null || url === '') {
      return true;
    }
    const re = /[\d\-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[\d\-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    return re.test(url);
  }

  static validateTextNumber(text) {
    if (text === null || text === '') {
      return true;
    }
    const re = /^[0-9]+(\.[0-9]{1,2})?$/;
    return re.test(text);
  }

  static textValidator = (regex, value) => {
    const charStart = '[';
    const charEnd = ']';
    const newRegex = regex ? regex.value.replace(charStart, '').replace(charEnd, '') : '/.*/';
    switch (newRegex) {
      case '/.*/':
        return null;
      case 'email':
        return !this.validateEmail(value) ? ERROR_INVALID_EMAIL : null;
      case 'url':
        return !this.validateUrl(value) ? ERROR_INVALID_URL : null;
      case 'number':
        return !this.validateTextNumber(value) ? ERROR_INVALID_NUMBER : null;
    }
    return null;
  };

  static formatCurrency = (amount, decimalCount = 2, decimal = '.', thousands = ',') => {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? '-' : '';
    amount = Math.abs(Number(amount / 100) || 0)
    const i = parseInt((amount.toFixed(decimalCount))).toString();
    const j = i.length > 3 ? i.length % 3 : 0;
    return (
      '$' +
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  };

  static formatDate = (date) => {
    const y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate();

    function z(i) {
      return i <= 9 ? '0' + i : i;
    }

    return y + '-' + z(m) + '-' + z(d);
  };

  static formatDateShow = (date) => {
    const y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate();

    function z(i) {
      return i <= 9 ? '0' + i : i;
    }

    return z(m) + '-' + z(d) + '-' + y;
  };

  static formatDateTime = (date) => {
    const y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate(),
      h = date.getHours(),
      i = date.getMinutes(),
      s = date.getSeconds(),
      l = date.getMilliseconds();

    function z(i) {
      return i <= 9 ? '0' + i : i;
    }

    return y + '-' + z(m) + '-' + z(d) + ' ' + z(h) + ':' + z(i) + ':' + z(s) + '.' + z(l);
  };

  static formatTime = (date) => {
    const h = date.getHours(),
      i = date.getMinutes(),
      s = date.getSeconds(),
      l = date.getMilliseconds();

    function z(i) {
      return i <= 9 ? '0' + i : i;
    }

    return z(h) + ':' + z(i) + ':' + z(s) + '.' + z(l);
  };

  static urlToFile = (url, filename, mimeType) => {
    return window
      .fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  static isOptionsField = (component) => {
    switch (component) {
      case 'checkbox':
      case 'radio':
      case 'select':
        return true;
      default:
        return false;
    }
  };

  static hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null;
  };

  static parseEmails(emails) {
    const results = [];
    if (emails) {
      emails.map((item) => {
        if (!Utils.isNull(item)) {
          results.push(item);
        }
      });
    }
    return !Utils.isEmpty(results) ? results : null;
  }

  static hasSubArray(mainArray, subArray) {
    mainArray = new Set(mainArray);
    subArray = new Set(subArray);

    for (const element of subArray) {
      if (!mainArray.has(element)) {
        return false;
      }
    }
    return true;
  }

  static sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  static capitalize = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  static LightenDarkenColor = (col, amt) => {
    let usePound = false;

    if (col[0] === '#') {
      col = col.slice(1);
      usePound = true;
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) {
      r = 255;
    } else if (r < 0) {
      r = 0;
    }

    let b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) {
      b = 255;
    } else if (b < 0) {
      b = 0;
    }

    let g = (num & 0x0000ff) + amt;

    if (g > 255) {
      g = 255;
    } else if (g < 0) {
      g = 0;
    }

    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
  };

  static getWeek = (day) => {
    const startDay = day.clone().startOf('week');
    const endDay = day.clone().endOf('week');

    const calendar = [];

    while (startDay.isBefore(endDay)) {
      startDay.add(1, 'day');
      calendar.push(startDay.clone());
    }

    return calendar;
  };

  static leoRedirect(path) {
    const url = window.location.origin + window.location.pathname + '#/' + path;
    if (window.location.href !== url) {
      window.location.replace(url);
    }
  }
}

export default Utils;
